import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SliderComponent {
  percent = 0
  @Input() min = 0
  @Input() max = 100
  @Output() change = new EventEmitter()

  @ViewChild('bar') bar?: ElementRef<HTMLDivElement>

  dragging = false

  constructor(private elementRef: ElementRef) {
  }

  setPercent(percent: number, emit = true) {
    this.percent = percent

    let value = this.calculateValue(percent)

    if (emit) {
      this.change.emit(value)
    }
  }

  setValue(value: number) {
    this.percent = this.calculatePercent(value)
  }

  calculateValue(percent: number) {
    const value = this.min + percent * (this.max - this.min) / 100
    return Math.round(value * 10) / 10
  }

  calculatePercent(value: number) {
    const percent = 100 * (value - this.min) / (this.max - this.min)
    return Math.round(percent * 10) / 10
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(e: Event) {
    const percent = this.getPercent(e as PointerEvent)

    this.setPercent(percent)

    this.dragging = true
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e: Event) {
    if (!this.dragging) {
      return
    }

    const percent = this.getPercent(e as PointerEvent)

    this.setPercent(percent)
  }

  getPercent(e: PointerEvent) {
    const x = e.pageX - this.elementRef.nativeElement.getBoundingClientRect().x
    const width = this.elementRef.nativeElement.clientWidth

    let percent = parseFloat((100 * x / width).toFixed(1))

    if (percent > 100) {
      percent = 100
    }

    if (percent < 0) {
      percent = 0
    }

    return percent
  }

  @HostListener('window:mouseup')
  onMouseUp() {
    this.dragging = false
  }
}
